import React from "react";
import { Link, useParams } from "react-router-dom";
import { RouteParams } from "../../../../common/utility";

interface StepSummaryCellProps {
  stepName: string;
  status: string;
  beginTimeDate: Date;
  value: number;
}

/**
 * Renders StepSummaryCell
 * @param props
 */
export default function StepSummaryCell(props: StepSummaryCellProps) {
  const { stepName, status, beginTimeDate, value } = props;
  const { workflowId } = useParams<RouteParams>();
  const linkToParams = {
    pathname: `/workflows/${workflowId}/viewWorkflowData`,
    state: {
      status,
      beginTimeDate,
      stepName
    }
  };
  return (
    <div>
      <Link to={linkToParams}>{value}</Link>
    </div>
  );
}
